import { useCallback } from 'react';

import { formatOdds as formatOddsUtils } from '@/utils/format-odds';

import { useOddsFormat } from './use-odds-format';

// Format odds based on the user's odds format preference
export const useFormatOdds = () => {
    const oddsFormat = useOddsFormat();

    const formatOdds = useCallback(
        (decimalOdds?: number, decimals = 2) => {
            return formatOddsUtils(oddsFormat, decimalOdds, decimals);
        },
        [oddsFormat]
    );

    return { formatOdds };
};
